import * as React from 'react';
import { isValidEmail, isValidPhone } from '../util/Validation';
import './signup.css';
import { SignupState, AccountType, AccountCreationRequest, AccountCreationError } from './signup.types';
import { CLIENT, ADMIN } from './signup.constants';
import Phone from 'react-phone-number-input';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { AuthState } from '../auth/auth.types';

const EMAIL_ERROR_MESSAGE = 'Please enter a valid email address';

type Props = {
  readonly authState: AuthState
  readonly signupState: SignupState
  readonly whichAccount: (value: AccountType) => void
  readonly emailValidationErrorHandler: (hasError: boolean) => void
  readonly accountCreationRequestHandler: (request: AccountCreationRequest) => void
  readonly accountCreationErrorHandler: (error: AccountCreationError) => void
  readonly accountCreationError: AccountCreationError
  readonly checkEmailAvailability: (email: string) => Promise<Response>
};

type States = {
  readonly accountCreationRequest: AccountCreationRequest
  readonly showAccountCreationErrorModal: boolean
  readonly accountCreationErrorModalMessage: string
  readonly errorMessage: string
};

class AccountCreationComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      accountCreationRequest: {
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        password: '',
        confirmPassword: ''
      },
      showAccountCreationErrorModal: false,
      accountCreationErrorModalMessage: '',
      errorMessage: ''
    };

    this.toggleSignupErrorModal = this.toggleSignupErrorModal.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onFirstNameChange = this.onFirstNameChange.bind(this);
    this.onLastNameChange = this.onLastNameChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onConfirmPasswordChange = this.onConfirmPasswordChange.bind(this);
    this.toggleAccountCreationErrorModal = this.toggleAccountCreationErrorModal.bind(this);
  }

  render() {
    const { errorMessage, accountCreationRequest } = this.state;
    const { emailError, phoneError, confirmPasswordError } = this.props.accountCreationError;

    return(
      <div className="container animated fadeIn bg-light">
        <div className="row no-gutters">
          <RadioButtonGroup
            name="accountSelection"
            defaultSelected={CLIENT}
            onChange={(event: object, value: AccountType) => this.props.whichAccount(value)}
          >
            <RadioButton value={CLIENT} label={CLIENT}/>
            <RadioButton value={ADMIN} label={ADMIN + ' (Use mimosa solutions email)'}/>
          </RadioButtonGroup>
        </div>
        <div className="row no-gutters">
          <div className="col-6 input-hp">
            <div className={(emailError ? 'has-danger ' : '') + 'input-group mb-2 mr-sm-2 mb-sm-0'}>
              <div className="input-group-addon">
                <i className="material-icons f3 input-icon">
                  email
                </i>
              </div>
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                value={accountCreationRequest.email}
                onChange={this.onEmailChange}
                onBlur={() => this.props.checkEmailAvailability(accountCreationRequest.email)}
              />
            </div>
            {
              this.props.accountCreationError.emailError ?
                (
                  <div className="tc w-100">
                    <p className="mv1 red f7">{emailError}</p>
                  </div>
                ) : 
                null
            }
          </div>
          <div className="col-6 input-hp">
            <div className={(phoneError ? 'has-danger ' : '') + 'input-group mb-2 mr-sm-2 mb-sm-0'}>
              <div className="input-group-addon">
                <i className="material-icons f3 input-icon">
                  phone
                </i>
              </div>
              <div className="form-control">
                <Phone
                  countries={['CA']}
                  value={accountCreationRequest.phone}
                  onChange={this.onPhoneChange}
                  convertToNational={true}
                  inputStyle={{
                    backgroundColor: 'transparent',
                    borderBottom: '0px',
                    height: 19
                  }}
                />
              </div>
            </div>
            {
              phoneError ?
                (
                  <div className="tc w-100">
                    <p className="mv1 red f7">{phoneError}</p>
                  </div>
                ) :
                null
            }
          </div>
        </div>
        <div className="row no-gutters mt2">
          <div className="col-6 input-hp">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <div className="input-group-addon">
                <i className="material-icons f3 input-icon">
                  person
                </i>
              </div>
              <input
                type="text"
                className="form-control"
                placeholder="First Name"
                value={accountCreationRequest.firstName}
                onChange={this.onFirstNameChange}
              />
            </div>
          </div>
          <div className="col-6 input-hp">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <div className="input-group-addon">
                <i className="material-icons f3 input-icon">
                  person
                </i>
              </div>
              <input
                type="text"
                className="form-control"
                placeholder="Last Name"
                value={accountCreationRequest.lastName}
                onChange={this.onLastNameChange}
              />
            </div>
          </div>
        </div>
        <div className="row no-gutters mt2">
          <div className="col-6 input-hp">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <div className="input-group-addon">
                <i className="material-icons f3 input-icon">
                  lock
                </i>
              </div>
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                value={accountCreationRequest.password}
                onChange={this.onPasswordChange}
              />
            </div>
          </div>
          <div className="col-6 input-hp">
            <div className={(confirmPasswordError ? 'has-danger ' : '') + 'input-group mb-2 mr-sm-2 mb-sm-0'}>
              <div className="input-group-addon">
                <i className="material-icons f3 input-icon">
                  lock
                </i>
              </div>
              <input
                type="password"
                className="form-control"
                placeholder="Confirm Password"
                value={accountCreationRequest.confirmPassword}
                onChange={this.onConfirmPasswordChange}
              />
            </div>
            {
              confirmPasswordError ?
                (
                  <div className="tc w-100">
                    <p className="mv1 red f7">{confirmPasswordError}</p>
                  </div>
                ) : 
                null
            }
          </div>
        </div>
        <hr />
        <div className="red">
          {errorMessage}
        </div>
      </div>
    );
  }

  private onEmailChange(event: React.FormEvent<HTMLInputElement>) {
    const newEmail = event.currentTarget.value;

    this.setState(
      {accountCreationRequest: {...this.state.accountCreationRequest, email: newEmail}},
      () => {
        this.props.accountCreationRequestHandler(this.state.accountCreationRequest);
        this.props.accountCreationErrorHandler({
          ...this.props.accountCreationError,
          emailError: isValidEmail(newEmail, EMAIL_ERROR_MESSAGE)
        });
      }
    );
  }
  
  private onFirstNameChange = (event: React.FormEvent<HTMLInputElement>): void =>
    this.setState(
      {accountCreationRequest: {...this.state.accountCreationRequest, firstName: event.currentTarget.value}},
      () => this.props.accountCreationRequestHandler(this.state.accountCreationRequest)
    )

  private onLastNameChange = (event: React.FormEvent<HTMLInputElement>): void =>
    this.setState(
      {accountCreationRequest: {...this.state.accountCreationRequest, lastName: event.currentTarget.value}},
      () => this.props.accountCreationRequestHandler(this.state.accountCreationRequest)
    )

  private onPhoneChange = (newValue: string): void =>
    this.setState(
      {accountCreationRequest: {...this.state.accountCreationRequest, phone: newValue}},
      () => {
        this.props.accountCreationRequestHandler(this.state.accountCreationRequest);
        this.props.accountCreationErrorHandler({
          ...this.props.accountCreationError,
          phoneError: isValidPhone(newValue, 'Please enter a valid phone number')
        });
      }
    )
  
  private onPasswordChange = (event: React.FormEvent<HTMLInputElement>): void => {
    const newPassword = event.currentTarget.value;

    this.setState(
      {accountCreationRequest: {...this.state.accountCreationRequest, password: newPassword}},
      () => {
        this.props.accountCreationRequestHandler(this.state.accountCreationRequest);
        this.props.accountCreationErrorHandler({
          ...this.props.accountCreationError,
          confirmPasswordError: (
            this.state.accountCreationRequest.confirmPassword === newPassword ?
              '' :
              'Password does not match'
          )
        });
      }
    );
  }
  
  private onConfirmPasswordChange = (event: React.FormEvent<HTMLInputElement>): void => {
    const newConfirmPassword = event.currentTarget.value;

    this.setState(
      {accountCreationRequest: {...this.state.accountCreationRequest, confirmPassword: newConfirmPassword}},
      () => {
        this.props.accountCreationRequestHandler(this.state.accountCreationRequest);
        this.props.accountCreationErrorHandler({
          ...this.props.accountCreationError,
          confirmPasswordError: (
            this.state.accountCreationRequest.password === newConfirmPassword ?
              '' :
              'Password does not match')
        });
      }
    );
  }

  private toggleAccountCreationErrorModal(message?: string) {
    this.setState({
      showAccountCreationErrorModal: !this.state.showAccountCreationErrorModal,
      accountCreationErrorModalMessage: (message) ? message : this.state.accountCreationErrorModalMessage
    });
  }

  private toggleSignupErrorModal(message?: string) {
    this.setState({
      showAccountCreationErrorModal: !this.state.showAccountCreationErrorModal,
      accountCreationErrorModalMessage: (message) ? message : this.state.accountCreationErrorModalMessage
    });
  }
}

export default AccountCreationComponent;



// WEBPACK FOOTER //
// ./src/admin/account.creation.component.tsx